export default __webpack_public_path__ + "static/media/tim-ios-activation-review.1f20ad0b.gif";